import styled from 'styled-components';
import { isIE11 } from '../../../../helpers/utils-helpers';

export const HistoryBehavioralDrawerSC = styled.div`
  min-height: 100%;
  display: flex;
  flex-direction: column;

  .hbd-header {
    padding: 68px 24px 24px;
    background-color: #333d6c;
    border-radius: 0 0 12px 12px;
    z-index: 2;
  }
  .hbd-date-picker {
    background: #f4f4f7;
    height: auto;
    padding: 26px 25px 16px 25px;
    margin-top: -10px;
    z-index: 1;
    &__counter {
      width: 100%;
      font-size: 14px;
      color: #333d6c;
      text-align: right;
      display: flex;
      padding-top: 10px;
      justify-content: flex-end;
    }
  }
  .hbd-body {
    display: ${isIE11 ? 'block' : 'flex'};
    flex-direction: column;
    flex: 1;
    min-height: 100%;
    position: relative;
    overflow: hidden;

    .hbd-body-content {
      display: flex;
      flex-grow: 1;
      position: relative;
    }

    .hbd-body-list {
      width: 100%;
      height: 100%;
      position: absolute;
      overflow-y: auto;
      overflow-x: hidden;
    }
  }

  .hbd-body-bottom {
    margin-top: auto;
    background-color: white;
    z-index: 1;
  }
`;
